// const tinycolor = require("tinycolor2");
import tinycolor from 'tinycolor2';

export const getErrorColor = (colors) => {

	// console.log(colors);

	// are any of the colours already red?
	// (get the most red)

	let reds = {};

	for (const c of colors) {
		let red = isRed(c);
		if (red) reds[c] = red;
	}

	if (Object.keys(reds).length) {
		let sorted = Object.entries(reds).sort((a, b) => b[1] - a[1]);
		// console.log(sorted);
		return sorted[0][0];
	}

	// do any of them have a triad or tetrad color that's red?
	for (const c of colors) {
		let tc = tinycolor(c);
		let triad = tc.triad();
		triad.shift();
		for (const cx of triad) {
			// console.log(cx.toHexString());
			if (isRed(cx)) return cx.toHexString();
		}
		let tetrad = tc.tetrad();
		tetrad.shift();
		for (const cy of tetrad) {
			// console.log(cy.toHexString());
			if (isRed(cy)) return cy.toHexString();
		}
	}

	// fallback to accent1
	return colors[0];

};

const isRed = (color) => {
	let tc = tinycolor(color);
	let hsv = tc.toHsv();
	let hue = hsv.h;
	// console.log(hsv);
	if (hsv.s > 0.2) { // not grey
		if (hsv.h > 320) return (100 - (360 - hsv.h));
		if (hsv.h < 30)  return (100 - hsv.h);
	}
	return 0;
};

export const getContrast = (color1, color2) => {
	return tinycolor.readability(color1, color2);
};

export const bestContrast = (basis, red, alt) => {

	// This differs from the one used in the platform
	// Here, all colors are raw hex colors and we return the best one
	// (not the name)

	// Also, we no longer skew by brightness, we hard skew instead to the red

	const contrast1 = getContrast(basis, red);
	const contrast2 = getContrast(basis, alt);

	// console.log(basis, red, contrast1);
	// console.log(basis, alt, contrast2);

	if (contrast1 > 4) {
		return red;
	} else {
		return (contrast2 > contrast1) ? alt : red;
	}

};

export const colorMix = (color_1, color_2, weight) => {
	// cf. https://gist.github.com/jedfoster/7939513
	function d2h(d) { return d.toString(16); }
	function h2d(h) { return parseInt(h, 16); }
	weight = (typeof(weight) !== 'undefined') ? weight : 50;
	color_1 = color_1.replace('#','');
	color_2 = color_2.replace('#','');
	let color = "#";
	for(let i = 0; i <= 5; i += 2) {
		let v1 = h2d(color_1.substr(i, 2));
		let v2 = h2d(color_2.substr(i, 2));
		// console.log(v1,v2);
		let val = d2h(Math.floor(v2 + (v1 - v2) * (weight / 100.0)));
		while(val.length < 2) { val = '0' + val; }
		color += val;
	}
	return color;
};

export const isDark = (color) => {
	// 16 Jul 2026
	// This has a much lower threshold for darkness than usual...
	if (!color) return null;
	// console.log('isDark',color,getBrightness(color));
	// return (getBrightness(color) < 50) ? true : false;
	return (getBrightness(color) < 120) ? true : false;
};

export const getBrightness = (color) => {
	if (!color) return null;
	let tc = tinycolor(color);
	return tc.getBrightness();
};
